import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TableContainer, TableHead, TableCell, TableBody, Table, TableRow, TextField, Tooltip } from "@material-ui/core"
import React, { Component, Fragment } from "react"
import CloseIcon from "@material-ui/icons/Close"
import Autocomplete from "@material-ui/lab/Autocomplete"
import axios from 'axios';
import InfoIcon from '@material-ui/icons/Info';
import { formValues, taskErrorCode } from "../containers/LLpTaskFormData"
import GetAppIcon from '@material-ui/icons/GetApp';
import AttachmentIcon from '@material-ui/icons/Attachment';
import LinkIcon from '@material-ui/icons/Link';
import { checkApiStatus, format_Commas, validationMess } from "../../../../utils";
import { addLLpTaskFormApi, deleteAttachment} from "../apiService";
import { fieldValidation } from "../../../../utils/formValidation";
import LLpConfirmDeleteAttachment from "./LLpConfirmDeleteAttachment";
import { regexConstants } from "../../../../constants/regEx";
import { globalPutService,globalGetService } from "../../../../utils/globalApiServices";
import LinkFiles from "../../../../shared_elements/components/LinkFiles";
import UploadFile from "../../../../shared_elements/components/UploadFile";
import { trackActivity } from '../../../../utils/mixpanel';
import { assetType, imgStoragePath,specificKey } from "../../../../constants";
import config from "../../../../config";
import { AutocompleteCreatable, PageLoader } from "../../../../shared_elements";
import { acumenCamo } from "../../../../shared_elements/components";
class LLpTaskForms extends Component {
	constructor(props) {
		super(props)
		this.state = {
			error: {},
			data: formValues,
			numberError: false,
			attachments: [],
			newUploadedAttachments: [],
			btnStatus: "",
			open: false,
			deleteAttachmentId: 0,
			showSuccessUpload: false,
			pndata:null,
			pageLoader:false,
			submitLoader: false,
		}

		this.addLLpTaskFormApi = addLLpTaskFormApi.bind(this)
		
	}

	handleOpenFile = () => {
		this.setState({ linkFile: true })
	};
	handleCloseFile = () => {
		this.setState({ linkFile: false })
	};
	handleOpenUploadFile = () => {
		this.setState({ uploadFile: true })
	};
	handleUploadFileCloseFile = () => {
		this.setState({ uploadFile: false })
	};

	componentDidMount = () => {
		this.getPnDropdown()
		if (this.props.editFormId) {
			this.fillEditData()
		}
		trackActivity('LLP ADD Modal Opened  - CAMO', {
			event_type: 'Modal Opened',
			page_title: 'LLP Add Task Form',
		})
	}

	onFieldChange = (keyParam, value, index) => {
		const { error,data } = this.state;
		if(keyParam ==='part_number' && !value){
			this.setState({data:formValues})
		}else if(keyParam ==='part_number' && value?.id){
		globalGetService(`camo/llp_part_number/2/part/?engine_id=${this.props?.props?.match.params?.asset}&part_number_id=${value?.id}`)
			.then(response => {
				if (response?.status === 200) {
					 this.setState({data: {...response?.data, serial_number:null}})
				}
			})
		}else{
		this.setState((prevState) => {
			const newData = { ...prevState.data };
			if (keyParam === "cootr_thrust") {
				const thrustKey = index >= 0 ? `COOTR_thrust_${String.fromCharCode(97 + index)}` : keyParam;
				newData[thrustKey] = format_Commas(value).replace(/[^0-9.]/g, '');
			} else if (keyParam === "life_limit") {
				const thrustKey = index >= 0 ? `life_limit_thrust_${String.fromCharCode(97 + index)}` : keyParam;
				newData[thrustKey] = regexConstants.alphanumespcespclchar.test(value) ? value :format_Commas(value).replace(/[^0-9.]/g, '')
				if (regexConstants.alphanumespcespclchar.test(value)) {
					this.setState({ error: {...error, [thrustKey] : value  === (null || undefined || "")  ? "" : !['NO LIMIT'].includes(value.toUpperCase()) && 'Allow keywords No limit or 0 to 99999'}, })
				} else if(regexConstants.onlyNumeric.test(value)) {
					this.setState({ error: {...error, [thrustKey] : value  === (null || undefined || "")  ? "" : ''} })
				}else{
					this.setState({ error: {...error, [thrustKey]:value  === null  || regexConstants.numberWithComma.test(value) || value === ""  ? "" : "Allow keywords No limit or 0 to 99999"}})
				}
			} else {
				newData[keyParam] = value;
			}
			return { data: newData };
		});
	}
		
	};
	getPnDropdown = (query) => {
		this.setState({pageLoader:true})
		globalGetService(`camo/llp_part_number/2/part/?engine_id=${this.props?.props?.match.params?.asset}`)
			.then(response => {
				this.setState({pageLoader:false})
				if (response?.status === 200) {
					this.setState({pndata:response?.data})
				} 
			})
	}

	onRestErrorKey = (keyParam, index) => {
		this.setState((prevState) => {
			const { error } = prevState;
			if (keyParam === "life_limit") {
				const updatedError = {};
				for (let i = 0; i < 5; i++) {
					const thrustKey = `life_limit_thrust_${String.fromCharCode(97 + i)}`;
					updatedError[thrustKey] = "";
				}
				return { error: { ...error, ...updatedError } };
			}

			return { error: { ...error, [keyParam]: "" } };
		});
	};

	handleSubmit = (e,btnStatus) => {
		e.preventDefault()
		if (this.state.submitLoader) {
			return
		}
		let validationInputs = {}
		const { data,error } = this.state
			const { thrust_detail } = this.props
			validationInputs = {
				...validationInputs,
				module_type: taskErrorCode["module_type"][fieldValidation({ ...taskErrorCode["module_type_obj"], fieldval: data.module_type, })],
				description:acumenCamo ? '' : taskErrorCode["description"][fieldValidation({ ...taskErrorCode["description_obj"], fieldval: data.description, })],
				part_number: taskErrorCode["part_number"][fieldValidation({ ...taskErrorCode["part_number_obj"], fieldval: data.part_number, })],
				serial_number: taskErrorCode["serial_number"][fieldValidation({ ...taskErrorCode["serial_number_obj"], fieldval: data.serial_number, })],
				tsn:acumenCamo ? '' : taskErrorCode["tsn"][fieldValidation({ ...taskErrorCode["tsn_obj"], fieldval: data.tsn, })],
				life_limit_thrust_a:acumenCamo ? '' : (data?.life_limit_thrust_a) || data?.life_limit_thrust_a  >= ( 0 || "0" ) ? '' : taskErrorCode["life_limit_thrust_a"][fieldValidation({ ...taskErrorCode["life_limit_thrust_a_obj"], fieldval: data.life_limit_thrust_a, })],
				life_limit_thrust_b:acumenCamo ? '' : (data?.life_limit_thrust_b) || data?.life_limit_thrust_b  >=  ( 0 || "0" ) ? '' : taskErrorCode["life_limit_thrust_b"][fieldValidation({ ...taskErrorCode["life_limit_thrust_b_obj"], fieldval: data.life_limit_thrust_b, })],
				life_limit_thrust_c:acumenCamo ? '' :thrust_detail && Object.values(thrust_detail)?.length === 2 ? '' : (data?.life_limit_thrust_c) || data?.life_limit_thrust_c >= ( 0 || "0") ? '' : taskErrorCode["life_limit_thrust_c"][fieldValidation({ ...taskErrorCode["life_limit_thrust_c_obj"], fieldval: data.life_limit_thrust_c, })],
				life_limit_thrust_d:acumenCamo ? '' : thrust_detail && Object.values(thrust_detail)?.length === 2 || Object.values(thrust_detail)?.length === 3 ? '' : (data?.life_limit_thrust_d) || data?.life_limit_thrust_d >= ( 0 || "0" ) ? '' : taskErrorCode["life_limit_thrust_d"][fieldValidation({ ...taskErrorCode["life_limit_thrust_d_obj"], fieldval: data.life_limit_thrust_d, })],
				life_limit_thrust_e:acumenCamo ? '' : thrust_detail && Object.values(thrust_detail)?.length === 2 || Object.values(thrust_detail)?.length === 3 ? '' :( data?.life_limit_thrust_e) || data?.life_limit_thrust_e >= ( 0 || "0" ) ? '' : taskErrorCode["life_limit_thrust_e"][fieldValidation({ ...taskErrorCode["life_limit_thrust_e_obj"], fieldval: data.life_limit_thrust_e, })],
				// life_limit_thrust_f: thrust_detail && Object.values(thrust_detail)?.length === 2 || Object.values(thrust_detail)?.length === 3 ||  Object.values(thrust_detail)?.length === 5 ? '' : data?.life_limit_thrust_f ? '' : taskErrorCode["life_limit_thrust_f"][fieldValidation({ ...taskErrorCode["life_limit_thrust_f_obj"], fieldval: data.life_limit_thrust_f, })],
			}
		if (data.tsn) {
			const { error } = this.state
			validationInputs = {
				...validationInputs,
				tsn:error?.tsn || '',
			}
		}
		if (data?.life_limit_thrust_a) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_a: (data?.life_limit_thrust_a)  ||  data?.life_limit_thrust_a  === ( 0 || "0")  ? '' : error?.life_limit_thrust_a || '',
			}
		}
		if (data?.life_limit_thrust_b) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_b: (data?.life_limit_thrust_b) || data?.life_limit_thrust_b  === ( 0 || "0")  ? '' : error?.life_limit_thrust_b || '',
			}
		}
		if (data?.life_limit_thrust_c) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_c: (data?.life_limit_thrust_c) || data?.life_limit_thrust_c  === ( 0 || "0")  ? '' : error?.life_limit_thrust_c || '',
			}
		}
		if (data?.life_limit_thrust_d) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_d: (data?.life_limit_thrust_d) || data?.life_limit_thrust_d  === ( 0 || "0")  ? '' : error?.life_limit_thrust_d || '',
			}
		}
		if (data?.life_limit_thrust_e) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_e: (data?.life_limit_thrust_e) || data?.life_limit_thrust_e  === ( 0 || "0")  ? '' : error?.life_limit_thrust_e || '',
			}
			
		}
		// if (data?.life_limit_thrust_f) {
		// 	validationInputs = {
		// 		...validationInputs,
		// 		life_limit_thrust_f: error?.life_limit_thrust_f || '',
		// 	}

		// }
		if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === "" })) {
			if (this.csnSum() > 99999) {
				this.setState({ csnError: 'CSN has reached its maximum limit of 99,999 Please check the CSN and contact support at support@sparta.aero.' });
				return;
			}
			const props = this.props.props
			let payload = Object.assign({}, data);
			delete payload.id;
			const parseThrust = (val) => {
				if (val === null || val === undefined || val === '') return null;
				const num = parseInt(val, 10);
				return Number.isNaN(num) ? null : num;
			};
			const parseLifeLimit = (val) => {
				if (val === null || val === undefined || val === '') return null;
				if (regexConstants.onlyNumeric.test(val)) {
					const num = parseInt(val, 10);
					return Number.isNaN(num) ? val : num;
				}
				return val;
			};
			const thrustKeys = [ 'COOTR_thrust_a', 'COOTR_thrust_b', 'COOTR_thrust_c', 'COOTR_thrust_d', 'COOTR_thrust_e', 'COOTR_thrust_f', ];
			const lifeLimitKeys = [ 'life_limit_thrust_a', 'life_limit_thrust_b', 'life_limit_thrust_c', 'life_limit_thrust_d', 'life_limit_thrust_e', 'life_limit_thrust_f',];
			const csnSum = thrustKeys?.reduce((sum, key) => { const v = parseThrust(data[key]); return sum + (v || 0); }, 0);
			const csn = csnSum ? (csnSum <= 99999 ? csnSum : 99999) : null;
			payload = {
				...payload,
				asset_id: props.match.params.asset,
				asset_type_id: props.match.params.assetType,
				part_number: payload.part_number || null,
				serial_number: payload.serial_number || null,
				tsn: payload.tsn || null,
				remarks: payload.remarks || null,
				csn,
			};
			thrustKeys?.forEach((key) => { payload[key] = parseThrust(data[key])});
			lifeLimitKeys?.forEach((key) => { payload[key] = parseLifeLimit(data[key])});
			// let payload = Object.assign({}, data)
			// delete payload?.id
			// const csnSum = parseInt(data.COOTR_thrust_a) + parseInt(data.COOTR_thrust_b) + parseInt(data.COOTR_thrust_c) + parseInt(data.COOTR_thrust_d) + parseInt(data.COOTR_thrust_e) || null
			// payload = {
			// 	...payload,
			// 	asset_id: props.match.params.asset,
			// 	asset_type_id: props.match.params.assetType,
			// 	part_number: payload.part_number || null,
			// 	serial_number: payload.serial_number || null,
			// 	tsn: payload.tsn || null,
			// 	remarks:payload?.remarks || null,
			// 	csn: csnSum <= 99999 ? csnSum : 99999 || null,
		    //     COOTR_thrust_a: data.COOTR_thrust_a === (null || undefined) || data.COOTR_thrust_a === ('' || "") ? null : data.COOTR_thrust_a >= 0 || '0' ? parseInt(data.COOTR_thrust_a) : null,
			// 	COOTR_thrust_b: data.COOTR_thrust_b === (null || undefined) || data.COOTR_thrust_b === ('' || "") ? null : data.COOTR_thrust_b >= 0 || '0' ? parseInt(data.COOTR_thrust_b) : null,
			// 	COOTR_thrust_c: data.COOTR_thrust_c === (null || undefined) || data.COOTR_thrust_c === ('' || "") ? null : data.COOTR_thrust_c >= 0 || '0' ? parseInt(data.COOTR_thrust_c) : null,
			// 	COOTR_thrust_d: data.COOTR_thrust_d === (null || undefined) || data.COOTR_thrust_d === ('' || "") ? null : data.COOTR_thrust_d >= 0 || '0' ? parseInt(data.COOTR_thrust_d) : null,
			// 	COOTR_thrust_e: data.COOTR_thrust_e === (null || undefined) || data.COOTR_thrust_e === ('' || "") ? null : data.COOTR_thrust_e >= 0 || '0' ? parseInt(data.COOTR_thrust_e) : null,
			// 	COOTR_thrust_f: data.COOTR_thrust_f === (null || undefined) || data.COOTR_thrust_f === ('' || "") ? null : data.COOTR_thrust_f >= 0 || '0' ? parseInt(data.COOTR_thrust_f) : null,
			// 	life_limit_thrust_a: data.life_limit_thrust_a === (null || undefined) ? null : data.life_limit_thrust_a ? regexConstants.onlyNumeric.test(data.life_limit_thrust_a) ? parseInt(data.life_limit_thrust_a) : data.life_limit_thrust_a : data.life_limit_thrust_a >= 0 || '0' ? data.life_limit_thrust_a : null,
			// 	life_limit_thrust_b: data.life_limit_thrust_b === (null || undefined ) ? null : data.life_limit_thrust_b ? regexConstants.onlyNumeric.test(data.life_limit_thrust_b) ? parseInt(data.life_limit_thrust_b) : data.life_limit_thrust_b : data.life_limit_thrust_b >= 0 || '0' ? data.life_limit_thrust_b : null,
			// 	life_limit_thrust_c: data.life_limit_thrust_c === (null || undefined) ? null : data.life_limit_thrust_c ? regexConstants.onlyNumeric.test(data.life_limit_thrust_c) ? parseInt(data.life_limit_thrust_c) : data.life_limit_thrust_c : data.life_limit_thrust_c >= 0 || '0' ? data.life_limit_thrust_c : null,
			// 	life_limit_thrust_d: data.life_limit_thrust_d === (null || undefined) ? null : data.life_limit_thrust_d ? regexConstants.onlyNumeric.test(data.life_limit_thrust_d) ? parseInt(data.life_limit_thrust_d) : data.life_limit_thrust_d : data.life_limit_thrust_d >= 0 || '0' ? data.life_limit_thrust_d : null,
			// 	life_limit_thrust_e: data.life_limit_thrust_e === (null || undefined) ? null : data.life_limit_thrust_e ? regexConstants.onlyNumeric.test(data.life_limit_thrust_e) ? parseInt(data.life_limit_thrust_e) : data.life_limit_thrust_e : data.life_limit_thrust_e >= 0 || '0' ? data.life_limit_thrust_e : null,
			// 	life_limit_thrust_f: data.life_limit_thrust_f === (null || undefined) ||  data.life_limit_thrust_f === ('' || "") ? null : data.life_limit_thrust_f ? regexConstants.onlyNumeric.test(data.life_limit_thrust_f) ? parseInt(data.life_limit_thrust_f) : data.life_limit_thrust_f : data.life_limit_thrust_f >= 0 || '0' ? data.life_limit_thrust_f : null,
			// }
			this.setState({ submitLoader: true })
			addLLpTaskFormApi(payload, props,this.props.addForm).then(async (response) => {
				const uploadId = response.data?.data?.id
				if (uploadId) {
					await this.uploadFileTest(uploadId, props, false)
					trackActivity('LLP Status Data Added Successfully - CAMO', {
						event_type: 'Data Added Successfully',
						page_title: 'LLP',
						item_id: uploadId ? uploadId : '',
						request_body: payload ? payload : '',
						response_msg: response.data.message ? response.data.message : ''
					})
				}
				this.setState({ submitLoader: false })
				if (btnStatus === "addAnother") {
					this.getPnDropdown()
				}
				this.props.getResponseBack()
				if (uploadId && this.state.btnStatus !== "addAnother") {
					this.props.closeAddForm()
				} else {
					return false
				}
			}).catch(() => {
				this.setState({ submitLoader: false })
			})
		

		} else {
			this.setState({ error: validationInputs })
			trackActivity('LLP Status Data Added Failed- CAMO', {
				event_type: 'Add Data Failed',
				page_title: 'LLP',
				error_source: 'Frontend',
				error_type: validationInputs ? validationInputs : ''
			})
		}
	}

	fillEditData = () => {
		const updateId = this.props.editFormId
		this.setState({ attachments: this.props.attachments })
		if (updateId === undefined || updateId === null) {
			this.setState({
				data: {},
			})
		} else {
			this.setState({
				data: this.props.editFormData,
			})
		}
	}

	updateData = async (e) => {
		e.preventDefault()
		let validationInputs = {}
		const { data,error} = this.state
			const { thrust_detail } = this.props
			validationInputs = {
				...validationInputs,
				module_type: taskErrorCode["module_type"][fieldValidation({ ...taskErrorCode["module_type_obj"], fieldval: data.module_type, })],
				description:acumenCamo ? '' : taskErrorCode["description"][fieldValidation({ ...taskErrorCode["description_obj"], fieldval: data.description, })],
				part_number: taskErrorCode["part_number"][fieldValidation({ ...taskErrorCode["part_number_obj"], fieldval: data.part_number, })],
				serial_number: taskErrorCode["serial_number"][fieldValidation({ ...taskErrorCode["serial_number_obj"], fieldval: data.serial_number, })],
				tsn: acumenCamo ? '' :taskErrorCode["tsn"][fieldValidation({ ...taskErrorCode["tsn_obj"], fieldval: data.tsn, })],
				life_limit_thrust_a:acumenCamo ? '' : (data?.life_limit_thrust_a) || data?.life_limit_thrust_a  >= ( 0 || "0" ) ? '' : taskErrorCode["life_limit_thrust_a"][fieldValidation({ ...taskErrorCode["life_limit_thrust_a_obj"], fieldval: data.life_limit_thrust_a, })],
				life_limit_thrust_b:acumenCamo ? '' : (data?.life_limit_thrust_b) || data?.life_limit_thrust_b  >=  ( 0 || "0" ) ? '' : taskErrorCode["life_limit_thrust_b"][fieldValidation({ ...taskErrorCode["life_limit_thrust_b_obj"], fieldval: data.life_limit_thrust_b, })],
				life_limit_thrust_c: acumenCamo ? '' :thrust_detail && Object.values(thrust_detail)?.length === 2 ? '' : (data?.life_limit_thrust_c) || data?.life_limit_thrust_c >= ( 0 || "0") ? '' : taskErrorCode["life_limit_thrust_c"][fieldValidation({ ...taskErrorCode["life_limit_thrust_c_obj"], fieldval: data.life_limit_thrust_c, })],
				life_limit_thrust_d: acumenCamo ? '' :thrust_detail && Object.values(thrust_detail)?.length === 2 || Object.values(thrust_detail)?.length === 3 ? '' : (data?.life_limit_thrust_d) || data?.life_limit_thrust_d >= ( 0 || "0" ) ? '' : taskErrorCode["life_limit_thrust_d"][fieldValidation({ ...taskErrorCode["life_limit_thrust_d_obj"], fieldval: data.life_limit_thrust_d, })],
				life_limit_thrust_e: acumenCamo ? '' :thrust_detail && Object.values(thrust_detail)?.length === 2 || Object.values(thrust_detail)?.length === 3 ? '' :( data?.life_limit_thrust_e) || data?.life_limit_thrust_e >= ( 0 || "0" ) ? '' : taskErrorCode["life_limit_thrust_e"][fieldValidation({ ...taskErrorCode["life_limit_thrust_e_obj"], fieldval: data.life_limit_thrust_e, })],
				// life_limit_thrust_f: thrust_detail && Object.values(thrust_detail)?.length === 2 || Object.values(thrust_detail)?.length === 3 || Object.values(thrust_detail)?.length === 5 ? '' : data?.life_limit_thrust_f ? '' : taskErrorCode["life_limit_thrust_f"][fieldValidation({ ...taskErrorCode["life_limit_thrust_f_obj"], fieldval: data.life_limit_thrust_f, })],
			}
		if (data?.tsn) {
			const { error } = this.state
			validationInputs = {
				...validationInputs,
				tsn:  error?.tsn || '',
			}
		}
			if (data?.life_limit_thrust_a) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_a: (data?.life_limit_thrust_a)  ||  data?.life_limit_thrust_a  === ( 0 || "0")  ? '' : error?.life_limit_thrust_a || '',
			}
		}
		if (data?.life_limit_thrust_b) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_b: (data?.life_limit_thrust_b) || data?.life_limit_thrust_b  === ( 0 || "0")  ? '' : error?.life_limit_thrust_b || '',
			}
		}
		if (data?.life_limit_thrust_c) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_c: (data?.life_limit_thrust_c) || data?.life_limit_thrust_c  === ( 0 || "0")  ? '' : error?.life_limit_thrust_c || '',
			}
		}
		if (data?.life_limit_thrust_d) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_d: (data?.life_limit_thrust_d) || data?.life_limit_thrust_d  === ( 0 || "0")  ? '' : error?.life_limit_thrust_d || '',
			}
		}
		if (data?.life_limit_thrust_e) {
			validationInputs = {
				...validationInputs,
				life_limit_thrust_e: (data?.life_limit_thrust_e) || data?.life_limit_thrust_e  === ( 0 || "0")  ? '' : error?.life_limit_thrust_e || '',
			}
			
		}
		// if (data?.life_limit_thrust_f) {
		// 	validationInputs = {
		// 		...validationInputs,
		// 		life_limit_thrust_f: error?.life_limit_thrust_f || '',
		// 	}
		// }
		if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === "" })) {
			if (this.csnSum() > 99999) {
				this.setState({ csnError: 'CSN has reached its maximum limit of 99,999 Please check the CSN and contact support at support@sparta.aero.' });
			return;
			}
			let payload = Object.assign({}, data) 
			delete payload.delete_status
			delete payload.delete_timestamp
			delete payload.deleted_by
			delete payload.restore_timestamp
			delete payload.restored_by
			delete payload.is_restored
			const parseThrust = (val) => {
				if (val === null || val === undefined || val === '') return null;
				const num = parseInt(val, 10);
				return Number.isNaN(num) ? null : num;
			};
			const parseLifeLimit = (val) => {
				if (val === null || val === undefined || val === '') return null;
				if (regexConstants.onlyNumeric.test(val)) {
					const num = parseInt(val, 10);
					return Number.isNaN(num) ? val : num;
				}
				return val;
			};
			const thrustKeys = [ 'COOTR_thrust_a', 'COOTR_thrust_b', 'COOTR_thrust_c', 'COOTR_thrust_d', 'COOTR_thrust_e', 'COOTR_thrust_f', ];
			const lifeLimitKeys = [ 'life_limit_thrust_a', 'life_limit_thrust_b', 'life_limit_thrust_c', 'life_limit_thrust_d', 'life_limit_thrust_e', 'life_limit_thrust_f',];
			const csnSum = thrustKeys?.reduce((sum, key) => { const v = parseThrust(data[key]); return sum + (v || 0); }, 0);
			const csn = csnSum ? (csnSum <= 99999 ? csnSum : 99999) : null;
			const updateId = this.props?.editFormId
			const props = this.props?.props
			payload = {
				...payload,
				id:updateId,
				asset_id: props.match.params.asset,
				asset_type_id: props.match.params.assetType,
				part_number: payload.part_number || null,
				serial_number: payload.serial_number || null,
				tsn: payload.tsn || null,
				remarks: payload.remarks || null,
				csn,
			};
			thrustKeys?.forEach((key) => { payload[key] = parseThrust(data[key])});
			lifeLimitKeys?.forEach((key) => { payload[key] = parseLifeLimit(data[key])});
			// const csnSum = parseInt(data.COOTR_thrust_a) + parseInt(data.COOTR_thrust_b) + parseInt(data.COOTR_thrust_c) + parseInt(data.COOTR_thrust_d) + parseInt(data.COOTR_thrust_e) || null
			// payload = {
			// 	...payload,
			// 	id:this.props?.editFormId,
			// 	asset_id: this.props?.props?.match?.params?.asset,
			// 	asset_type_id: this.props?.props?.match?.params?.assetType,
         	//     part_number: payload.part_number || null,
			// 	serial_number: payload.serial_number || null,
			// 	tsn: payload.tsn  || null,
			// 	remarks:payload?.remarks || null,
			// 	csn: csnSum <= 99999 ? csnSum : 99999 || null,
			// 	COOTR_thrust_a: data.COOTR_thrust_a === (null || undefined) || data.COOTR_thrust_a === ('' || "") ? null : data.COOTR_thrust_a >= 0 || '0' ? parseInt(data.COOTR_thrust_a) : null,
			// 	COOTR_thrust_b: data.COOTR_thrust_b === (null || undefined) || data.COOTR_thrust_b === ('' || "") ? null : data.COOTR_thrust_b >= 0 || '0' ? parseInt(data.COOTR_thrust_b) : null,
			// 	COOTR_thrust_c: data.COOTR_thrust_c === (null || undefined) || data.COOTR_thrust_c === ('' || "") ? null : data.COOTR_thrust_c >= 0 || '0' ? parseInt(data.COOTR_thrust_c) : null,
			// 	COOTR_thrust_d: data.COOTR_thrust_d === (null || undefined) || data.COOTR_thrust_d === ('' || "") ? null : data.COOTR_thrust_d >= 0 || '0' ? parseInt(data.COOTR_thrust_d) : null,
			// 	COOTR_thrust_e: data.COOTR_thrust_e === (null || undefined) || data.COOTR_thrust_e === ('' || "") ? null : data.COOTR_thrust_e >= 0 || '0' ? parseInt(data.COOTR_thrust_e) : null,
			// 	COOTR_thrust_f: data.COOTR_thrust_f === (null || undefined) || data.COOTR_thrust_f === ('' || "") ? null : data.COOTR_thrust_f >= 0 || '0' ? parseInt(data.COOTR_thrust_f) : null,
			// 	life_limit_thrust_a: data.life_limit_thrust_a === (null || undefined) ? null : data.life_limit_thrust_a ? regexConstants.onlyNumeric.test(data.life_limit_thrust_a) ? parseInt(data.life_limit_thrust_a) : data.life_limit_thrust_a : data.life_limit_thrust_a >= 0 || '0' ? data.life_limit_thrust_a : null,
			// 	life_limit_thrust_b: data.life_limit_thrust_b === (null || undefined ) ? null : data.life_limit_thrust_b ? regexConstants.onlyNumeric.test(data.life_limit_thrust_b) ? parseInt(data.life_limit_thrust_b) : data.life_limit_thrust_b : data.life_limit_thrust_b >= 0 || '0' ? data.life_limit_thrust_b : null,
			// 	life_limit_thrust_c: data.life_limit_thrust_c === (null || undefined) ? null : data.life_limit_thrust_c ? regexConstants.onlyNumeric.test(data.life_limit_thrust_c) ? parseInt(data.life_limit_thrust_c) : data.life_limit_thrust_c : data.life_limit_thrust_c >= 0 || '0' ? data.life_limit_thrust_c : null,
			// 	life_limit_thrust_d: data.life_limit_thrust_d === (null || undefined) ? null : data.life_limit_thrust_d ? regexConstants.onlyNumeric.test(data.life_limit_thrust_d) ? parseInt(data.life_limit_thrust_d) : data.life_limit_thrust_d : data.life_limit_thrust_d >= 0 || '0' ? data.life_limit_thrust_d : null,
			// 	life_limit_thrust_e: data.life_limit_thrust_e === (null || undefined) ? null : data.life_limit_thrust_e ? regexConstants.onlyNumeric.test(data.life_limit_thrust_e) ? parseInt(data.life_limit_thrust_e) : data.life_limit_thrust_e : data.life_limit_thrust_e >= 0 || '0' ? data.life_limit_thrust_e : null,
			// 	life_limit_thrust_f: data.life_limit_thrust_f === (null || undefined) ||  data.life_limit_thrust_f === ('' || "") ? null : data.life_limit_thrust_f ? regexConstants.onlyNumeric.test(data.life_limit_thrust_f) ? parseInt(data.life_limit_thrust_f) : data.life_limit_thrust_f : data.life_limit_thrust_f >= 0 || '0' ? data.life_limit_thrust_f : null,
			// }
			if (updateId) {
				this.uploadFileTest(updateId, props, true)
			}
			this.props.updateFormData(updateId, payload, props,this.props.addForm,this.props.closeAddForm)
			// this.props.closeAddForm()
			trackActivity('LLP Status Updated Successfully - CAMO', {
				event_type: 'Data Updated Successfully',
				page_title: 'LLP',
				item_id: updateId ? updateId : '',
				request_body: payload ? payload : ''
			})
			this.setState({ error: validationInputs })
		} else {
			this.setState({ error: validationInputs })
			trackActivity('LLP Status Updated Failed - CAMO', {
				event_type: 'Update Data Failed',
				page_title: 'LLP',
				error_source: 'Frontend',
				error_type: validationInputs ? validationInputs : ''
			})
		}
	}

	uploadFileTest = async (uploadId, props, isUpdate) => {
		if (this.state.newUploadedAttachments.length > 0) {
			let newAttachmentObj = []
			let formdata = new FormData()
			const module_type_id = 8
			Object.keys(this.state.newUploadedAttachments).map((key, index) => {
				newAttachmentObj.push({
					file: this.state.newUploadedAttachments[key],
					file_name: this.state.newUploadedAttachments[key].name,
					file_type: this.state.newUploadedAttachments[key].type,
					module_type_id,
					module_id: uploadId,
					asset_id: this.props.props.match.params.asset,
					asset_type_id: this.props.props.match.params.assetType

				})
				formdata.append(
					"[" + key + "]file",
					this.state.newUploadedAttachments[key]
				)
				formdata.append(
					"[" + key + "]file_type",
					this.state.newUploadedAttachments[key].type
				)
				formdata.append(
					"[" + key + "]file_name",
					this.state.newUploadedAttachments[key].name
				)
				formdata.append("[" + key + "]module_id", uploadId)
				formdata.append("[" + key + "]module_type_id", module_type_id)
				formdata.append("[" + key + "]asset_id", this.props.props.match.params.asset)
				formdata.append("[" + key + "]asset_type_id", this.props.props.match.params.assetType)
			})
			// uploadOccmFile(uploadId, formdata, props)
			this.props.fileUploadData(uploadId, formdata, props, true)
			if (this.state.btnStatus === "addAnother") {
				this.resetBothAttachmentArray()
			}
			if (!isUpdate) {
				this.onSubmitFileLink(uploadId)
				this.props.fileUploadData(uploadId, null, props, false)
			}
		} else {
			if (this.state.btnStatus === "addAnother") {
				this.setState((prevState) => ({
					...prevState,
					data: formValues,
					attachments: [],
				}))
				document.getElementById("asset-form").reset()
				this.props.fileUploadData(uploadId, null, props, false)
			} else {
				if (!isUpdate) {
					this.onSubmitFileLink(uploadId)
					this.props.fileUploadData(uploadId, null, props, false)
				}
			}
		}
	}

	resetBothAttachmentArray = () => {
		this.setState((prevState) => ({
			...prevState,
			data: formValues,
			attachments: [],
			newUploadedAttachments: [],
			open: false,
			deleteAttachmentId: 0,
		}))
		document.getElementById("asset-form").reset()
	}

	onUpload = (files) => {
		const chosenFiles = Array.prototype.slice.call(files)
		for (let i = 0; i < chosenFiles.length; i++) {
			if (chosenFiles[i].size > 52428800) {
				this.props.props.enqueueSnackbar(
					`${chosenFiles[i].name} Maximum file size should be 50MB.`,
					{
						variant: "error",
						anchorOrigin: { vertical: "top", horizontal: "right" },
					}
				)
				delete chosenFiles[i]
				continue
			} else {
				this.handleUploadFiles(chosenFiles)
				// document.querySelector(".MuiDialog-paper").scrollTop = 800;
				this.setState({
					showSuccessUpload: true,
				})
				setTimeout(() => {
					if (this.state.attachments) {
						this.setState({
							showSuccessUpload: false,
						})
					}
				}, 2500)
			}
		}
	}


	handleUploadFiles = (files) => {
		const uploaded = [...this.state.newUploadedAttachments]
		const existingAttachments = [...this.state.attachments]
		files.some((file) => {
			uploaded.push(file)
		})
		files.map((file) => {
			var objc = {
				id: 0,
				module_id: 0,
				module_type_id: 8,
				file_name: file.name,
				file_type: file.type,
				file: "",
				name: file.name,
			}
			existingAttachments.push(objc)
		})
		this.setState({
			newUploadedAttachments: uploaded,
			attachments: existingAttachments,
		})
	}

	handleClickAttachment = (e, id) => {
		this.setState({ open: true })
		this.setState({ deleteAttachmentId: id })
	}

	handleCloseAttachment = (e) => {
		this.setState({ open: false })
		this.setState({ deleteAttachmentId: 0 })
	}

	deleteAttachmentFile = async (id, file) => {
		if (id !== undefined && id != 0) {
			const props = this.props.props
			deleteAttachment(id, props)
			var array = [...this.state.attachments]
			array = array.filter((item) => item.id !== id)
			this.setState({ attachments: array, open: false, deleteAttachmentId: 0 })
		} else {
			this.onRemoveCamoFile(file)
		}
	}


	saveAndAddAnother = async (e) => {
		await this.setState({ btnStatus: "addAnother" })
		await this.handleSubmit(e,'addAnother')
	}

	addFormData = async (e) => {
		await this.setState({ btnStatus: "add" })
		this.handleSubmit(e)
	}
	downloadFile = (file) => {
		axios.get(decodeURIComponent(file.path), { timeout: 600000, responseType: 'blob' })
			.then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', file.name);
				document.body.appendChild(link);
				link.click();
			})
	}
	onUnlinkCheckListFile = (checklist, fileId) => {
		const { data } = this.state;
		let payload = {};
		payload.delete = true;
		payload.folder_ids = checklist?.folders?.filter(items => items.type === 'folder').map(file => file.id).filter((id) => id !== fileId).join(',');
		payload.file_ids = checklist?.files?.filter(items => items.type === 'file').map(file => file.id).filter((id) => id !== fileId).join(',');
		globalPutService(`camo/llp/${this.props.editFormId}/document-checklists/`, payload)
			.then((response) => {
				if (checkApiStatus(response)) {
					const updatedChecklist = { ...checklist };
					updatedChecklist.files = updatedChecklist.files.filter((file) => file.id !== fileId);
					updatedChecklist.folders = updatedChecklist?.folders.filter((file) => file.id !== fileId);
					this.setState({
						data: {
							...data,
							checklist: updatedChecklist,
						},
					});
				}
				trackActivity('LLP Status - CAMO', {
					event_type: 'Checklist File Unlinked',
					page_title: 'LLP',
					file_id: fileId ? fileId : '',
					edited_form_id: this.props.editFormId ? this.props.editFormId : '',
					request_body: payload ? payload : ''
				})
			});
	}
	onRemoveFile = (file) => {
		const { data } = this.state;
		this.setState({
			data: {
				...data,
				checklist: data.checklist.filter(item => item.name !== file.name)
			}
		});
	}

	getResponseBack = (file) => {
		const { data, } = this.state
		this.setState({
			data: {
				...data,
				checklist: file,
			},
		});
	}
	listResponseBack = (file) => {
		this.props.getResponseBack(file)
	}

	onRemoveCamoFile = (file) => {
		const { attachments } = this.state;
		this.setState({
			attachments: attachments.filter(item => item.file_name !== file.file_name)
		});
	}

	onLinkFile = (file, uuid, type) => {
		if (type == "link" || uuid) {
			const { data } = this.state;
			const folderUUID = [...data.folder_uuid, uuid];
			const updatedChecklist = [...data.checklist, file];

			let uuidData = [];
			let output = [];

			for (const arr of folderUUID) {
				uuidData = uuidData.concat(arr);
			}

			for (const arr of updatedChecklist) {
				output = output.concat(arr);
			}
			this.setState({
				data: {
					...data,
					checklist: output,
					folder_uuid: uuidData.join("")
				},
			});
		} else {
			this.onUpload(file)
		}
	}

	onSubmitFileLink = (id) => {
		const { data } = this.state;
		if (data.checklist?.length > 0 && data.checklist.map(item => item.id).filter(item => item)) {
			let payload = {};
			if (data?.checklist.some(item => item.type === 'folder') && data?.checklist.some(item => item.type === 'file')) {
				payload.folder_ids = data?.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
				payload.file_ids = data?.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
			} else if (data?.checklist.some(item => item.type === 'folder')) {
				payload.folder_ids = data?.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
			} else {
				payload.file_ids = data?.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
			}
			globalPutService(`camo/llp/${id}/document-checklists/`, payload)
				.then(response => {
					if (checkApiStatus(response)) {
						this.props.getResponseBack()
					} else {
						this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
					}
				});
		}
		if (data?.folder_uuid?.length > 0 && data.folder_uuid) {
			let formData = new FormData();
			formData.append('folder_uuid', data.folder_uuid);
			for (let i = 0; i < data.checklist.filter(item => item instanceof File).length; i++) {
				formData.append('files[]', data.checklist.filter(item => item instanceof File).length && data.checklist.filter(item => item instanceof File)[i]);
			}
			globalPutService(`camo/llp/${id}/document-checklists/`, formData)
				.then(response => {
					if (checkApiStatus(response)) {
						this.props.getResponseBack()
					} else {
						this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
					}
				});
		}
	}
	lifeLimithelperText = (index) => {
		const { error } = this.state;
		const thrustKey = `life_limit_thrust_${String.fromCharCode(97 + index)}`;
		return error[thrustKey] || "";
	}

	lifeLimitError = (index) => {
		const { error } = this.state;
		const thrustKey = `life_limit_thrust_${String.fromCharCode(97 + index)}`;
		return !!error[thrustKey];
	}

	operatedThrustValue = (index) => {
		const { data } = this.state;
		const thrustKey = `COOTR_thrust_${String.fromCharCode(97 + index)}`;
		return format_Commas(data[thrustKey]) || '';
	}

	lifeLimitValue = (index) => {
		const { data } = this.state;
		const thrustKey = `life_limit_thrust_${String.fromCharCode(97 + index)}`;
		return format_Commas(data[thrustKey]) || '';
	}
	
	remainingCycle = (index) => {
		const { data } = this.state;
		const thrustKeys = ['a', 'b', 'c', 'd', 'e','f'];
		let totalFraction = 0;

		thrustKeys?.length > 0 && thrustKeys?.forEach((key) => {
			const operated = parseInt(data[`COOTR_thrust_${key}`]) || 0;
			const limitRaw = data[`life_limit_thrust_${key}`];
			const limit = (limitRaw && !isNaN(limitRaw) && limitRaw !== 'No Limit') ? parseInt(limitRaw) : 0;
			totalFraction += (limit > 0 ? operated / limit : 0);
		});
		
		const thrustKey = thrustKeys[index];
		const lifeLimitRaw = data[`life_limit_thrust_${thrustKey}`];
		const lifeLimit =  (lifeLimitRaw && !isNaN(lifeLimitRaw) && lifeLimitRaw !== 'No Limit') ? parseInt(lifeLimitRaw) : 0;
		const remaining = Math.round((1 - totalFraction) * lifeLimit);
		data[`remaining_cycle_thrust_${thrustKey}`] =( lifeLimitRaw === '' || lifeLimitRaw === null)  && remaining === 0  ? '' : remaining <=0 ? "0" : remaining;
		return lifeLimitRaw === (null || undefined)  ? '' : data[`remaining_cycle_thrust_${thrustKey}`];
	};

	csnSum = () => {
		const { data } = this.state;
		const { thrust_detail } = this.props;
		const getSafeInt = (val) => {
			const num = parseInt(val);
			return isNaN(num) || num < 0 ? 0 : num;
		};
		let sum = 0;
		if (thrust_detail && Object.keys(thrust_detail)?.length === 6) {
			sum = getSafeInt(data?.COOTR_thrust_a) + getSafeInt(data.COOTR_thrust_b) + getSafeInt(data.COOTR_thrust_c) + getSafeInt(data.COOTR_thrust_d) + getSafeInt(data.COOTR_thrust_e) + getSafeInt(data.COOTR_thrust_f);
		}
		else if (thrust_detail && Object.keys(thrust_detail)?.length === 5) {
			sum = getSafeInt(data?.COOTR_thrust_a) + getSafeInt(data.COOTR_thrust_b) + getSafeInt(data.COOTR_thrust_c) + getSafeInt(data.COOTR_thrust_d) + getSafeInt(data.COOTR_thrust_e);
		} else if (thrust_detail && Object.keys(thrust_detail)?.length === 3) {
			sum = getSafeInt(data.COOTR_thrust_a) + getSafeInt(data.COOTR_thrust_b) + getSafeInt(data.COOTR_thrust_c);
		} else if (thrust_detail && Object.keys(thrust_detail)?.length === 2) {
			sum = getSafeInt(data?.COOTR_thrust_a) + getSafeInt(data.COOTR_thrust_b);
		} else {
			sum = getSafeInt(data?.csn);
		}
		return sum || '';
	};

	componentDidUpdate(prevProps, prevState) {
		const currentSum = this.csnSum();
		if (currentSum > 99999 && this.state.csnError !== 'CSN has reached its maximum limit of 99,999 Please check the CSN and contact support at support@sparta.aero.') {
			this.setState({ csnError: 'CSN has reached its maximum limit of 99,999 Please check the CSN and contact support at support@sparta.aero.' });
		} else if (currentSum <= 99999 && this.state.csnError !== '') {
			this.setState({ csnError: '' });
		}
	}



	render() {
		const { data, error, attachments,limit_key,pndata ,pageLoader, submitLoader} = this.state
		const { thrust_detail } = this.props
		const thrust = ["Thrust A", "Thrust B", "Thrust C", "Thrust D", "Thrust E"]
	    const modulType = ["FAN", "LPC", "HPC", "HPT",  "LPT", "STATIC", "BLADES"]
		return (
			<Fragment>
				<div id="AmpTaskForm">
					<div id="adTaskForm">
						<DialogTitle>
							{this.props.formTitle}
							<CloseIcon
								onClick={() => { this.props.closeAddForm(); this.listResponseBack() }}
								className="close-icon"
							/>
						</DialogTitle>
						<form
							id="asset-form"
							onSubmit={this.props.actionType === "add" ? (e) => this.handleSubmit(e) : (e) => this.updateData(e)}
						>
							<DialogContent>
								<Grid spacing={1} container>
									<Grid item md={3} sm={6} xs={12}>
										{(() => {
											 let optionValue = data?.part_number && pndata && pndata?.filter(item=>item?.part_number).map((pn,index)=>({id:pn?.id,name:pn?.part_number})).find((pn) => pn?.part_number === data?.part_number) || null;
											 if ((optionValue === null || optionValue === undefined) && data?.part_number) {
											 	optionValue = { part_number: data?.part_number }
											 }
											return (
												<AutocompleteCreatable
													options={pndata && pndata?.filter(item=>item?.part_number).map((pn,index)=>({id:pn?.id,name:pn?.part_number})) || []}
													paramsKey='part_number'
													optionKey='name'
													value={optionValue?.part_number || ''}
													multiple={false}
													onFieldChange={(e, paramsKey, newValue) => {this.onFieldChange('part_number', newValue?.id ? newValue : newValue?.value );this.onRestErrorKey("part_number") }}
													label={'Part Number'}
													// disableClearable={true}
													// filterSelectedOption={true}
													variant="outlined"
													required={true}
													error={error?.part_number}
													helperText={error?.part_number}
												/>
											)
										})()
										}
									</Grid>
									<Grid item md={3} sm={6} xs={12}>
										<TextField
											required
											variant="outlined"
											label="Serial Number"
											name="ad_no"
											id="serial_number"
											inputProps={{ maxLength: 50 }}
											InputLabelProps={{ shrink: true }}
											value={data?.serial_number ?? ''}
											error={data?.serial_number? false :error?.serial_number ? true : false}
											helperText={data?.serial_number? false : error?.serial_number ? error?.serial_number : ""}
											onChange={(e) =>{this.onFieldChange('serial_number', e.target.value); this.onRestErrorKey("serial_number")}} // change as per validation sheet
											// onChange={(e) => { e.target.value.length <= 50 && (regexConstants.alphanumericWithHyphen.test(e.target.value) || e.target.value === "") && this.onFieldChange('serial_number', e.target.value); this.onRestErrorKey("serial_number") }}
										/>
									</Grid>
									<Grid item md={3} sm={6} xs={12}>
										<TextField
											required={acumenCamo ? false :true}
											variant="outlined"
											label={
												<span style={{ verticalAlign: 'super' }}>
													TSN
													<Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
														<InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
													</Tooltip>
												</span>
											}
											name="tsn"
											id="tsn"
											error={acumenCamo ? false : data?.tsn ? false : error?.tsn ? true : false}
											helperText={acumenCamo ? '' : data?.tsn ? false :  error?.tsn ? error.tsn : ""}
											inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data?.tsn) && 10 }}
											InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
											value={data?.tsn === undefined ? '' : regexConstants.alphanumespcespclchar.test(data?.tsn) ? data?.tsn : format_Commas(data?.tsn?.replace(/[^0-9.]/g, ''))}
											onChange={(e) => {
												const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
												const numericValue = value.replace(/[^\d.]/g, '');
												const dotCount = (numericValue.match(/\./g) || []).length;
												const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
												if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
													this.onFieldChange("tsn", e.target.value);
													this.setState({ error: {...error, tsn:e.target.value  === (null || undefined || "")  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess("TSN",true)}, })
												} else if (isValid || value === "") {
													this.onFieldChange("tsn", numericValue);
													this.onRestErrorKey("tsn");
												}
												
											}}
										/>
									</Grid>
									<Grid item md={3} sm={6} xs={12}>
										<TextField
											variant="outlined"
											label="CSN"
											disabled
											InputLabelProps={{ shrink: true }}
											value={this.csnSum() || ''}
											error={!!this.state.csnError}
											helperText={this.state.csnError}
										/>
									</Grid>
								</Grid>
								<Grid spacing={1} container>
									<Grid item md={3} sm={6} xs={12}>
										<Autocomplete
											options={modulType || []}
											getOptionLabel={(option) => option}
											id="module_type"
											value={data?.module_type ? data?.module_type : null}
											onChange={(e, value) => { this.onFieldChange("module_type", value); this.onRestErrorKey("module_type") }}
											renderInput={(params) => (
												<TextField
													{...params}
													required
													label="Module"
													margin="normal"
													fullWidth
													error={ data?.module_type ? false : error?.module_type ? true : false}
													helperText={ data?.module_type ? false :  error?.module_type ? error?.module_type : ""}
													InputLabelProps={{ shrink: true }}
													placeholder="Select Module"
													variant="outlined"

												/>
											)}
										/>
									</Grid>
									<Grid item md={12} sm={6} xs={12}>
										<TextField
											required={acumenCamo ? false :true}
											multiline
											variant="outlined"
											label="Description"
											error={data?.description ? false : error?.description ? true : false}
											helperText={data?.description ? false : error?.description ? error?.description : ""}
											InputLabelProps={{ shrink: true }}
											value={data?.description}
											onChange={(e) => { this.onFieldChange("description", e.target.value);this.onRestErrorKey("description") }}
											inputProps={{ maxLength: 50 }}
										/>
									</Grid>
								</Grid>
								<Grid spacing={1} container>
									<TableContainer>
										<Table aria-label="simple table">
											<TableHead style={{ background: '#f0f2f3' }}>
												<TableRow>
													<TableCell>Thrust</TableCell>
													<TableCell align="left">Cycles Operated</TableCell>
													<TableCell align="left">Life Limit  <sup style={{ color: " #ff0000", fontSize: "14px", position: "relative", top: 0 }}>{ acumenCamo ? null : "*"} </sup></TableCell>
													<TableCell align="left">Remaining Cycles</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{(thrust_detail && Object.keys(thrust_detail)?.length === 6 ? thrust_detail && Object.values(thrust_detail) : thrust_detail && Object.keys(thrust_detail)?.length === 5 ? thrust_detail && Object.values(thrust_detail) : thrust_detail && Object.keys(thrust_detail)?.length === 2 ? thrust_detail && Object.values(thrust_detail) : thrust_detail && Object.keys(thrust_detail)?.length === 3 ? thrust_detail && Object.values(thrust_detail) : thrust).map((row, index) => (
													<TableRow >
														<TableCell> {row} </TableCell>
														<TableCell>
															<TextField
																variant="outlined"
																name="cootr_thrust"
																keyParams="cootr_thrust"
																id="cootr_thrust"
																inputProps={{maxLength:regexConstants.numberWithComma.test(this.operatedThrustValue(index)) ? 6 : 6 }}
																// onChange={(e) => { e.target.value.length <= 10 && (regexConstants.onlyNumeric.test(e.target.value) || e.target.value === "") && this.onFieldChange('cootr_thrust', e.target.value, index); this.onRestErrorKey("cootr_thrust") }}
																// onChange={(e) => this.onFieldChange('cootr_thrust', e.target.value, index)}
																value={this.operatedThrustValue(index)}
																onChange={(e) => {
																	 if (regexConstants.onlyNumeric.test(e.target.value?.replace(',', ''))) {
																		this.onFieldChange('cootr_thrust', e.target.value, index);
																	} else {
																		(regexConstants.onlyNumeric.test(format_Commas(e.target.value)?.replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('cootr_thrust', e.target.value, index);
																	}
																}
																}
															/>
														</TableCell>
														<TableCell>
															<TextField
																variant="outlined"
																error={acumenCamo ? false : this.lifeLimitError(index)}
																helperText={acumenCamo ? '' : this.lifeLimithelperText(index)}
																inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(this.lifeLimitValue(index)) ? 8 : 6 }}
																value={this.lifeLimitValue(index)}
																onFocus={() => this.setState({ ...error, 'life_limit': '' })}
																onChange={(e) => {
																	if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
																		this.onFieldChange('life_limit', e.target.value, index);
																	} else if (regexConstants.onlyNumeric.test(e.target.value?.replace(',', ''))) {
																		this.onFieldChange('life_limit', e.target.value, index);
																	} else {
																		(regexConstants.onlyNumeric.test(format_Commas(e.target.value)?.replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('life_limit', e.target.value, index);
																	}
																}
																}
															/>
														</TableCell>
														<TableCell> <TextField variant="outlined"
															disabled
															value={this.remainingCycle(index) || ''}
															// value={thrust_detail && Object.keys(thrust_detail)?.length === 5 ? this.remainingCycle_thrustabcde(index) || '' : thrust_detail && Object.keys(thrust_detail)?.length === 3 ? this.remainingCycle_thrustabc(index) || '' : thrust_detail && Object.keys(thrust_detail)?.length === 2 && this.remainingCycle_thrustab(index) || ''}
														/>
														</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
									</TableContainer>
								</Grid>
								<Grid spacing={1} container>
									<Grid item md={6} sm={6} xs={12}>
										<TextField
											label="Remarks"
											margin='normal'
											variant='outlined'
											fullWidth
											value={data?.remarks}
											InputLabelProps={{ shrink: true }}
											onChange={(e) => this.onFieldChange("remarks", e.target.value)}
											rows={3}
											multiline
											inputProps={{ maxLength: 250 }}
										/>
									</Grid>
									<Grid item md={6} sm={6} xs={12}>
										<div className="upload-amp-textbox" style={{ border: "1px solid gray", textAlign: 'center' }}>
											<ul className="list-inline spacing-list">
												<li className="list-inline-item" onClick={this.handleOpenUploadFile} >
													<span className="flex-centered"><AttachmentIcon color='primary' fontSize='small' /> Upload File</span>
												</li>
												<li className="list-inline-item" onClick={this.handleOpenFile}>
													<span className="flex-centered"><LinkIcon color='primary' fontSize='small' />Link file from Records Module</span>
												</li>
											</ul>
										</div>
									</Grid>
									<Grid id="data-container" spacing={1} container>
										<Grid spacing={1} container>
											{this.props.actionType === 'add' ?
												<div className='checklist-files'>
													<ul className='list-inline'>
														{data?.checklist?.map((file) =>
															<li className='list-inline-item'>
																<span className='file-name'>{file.name}</span>
																<span className='file-remove'>
																	<a href={decodeURIComponent(file.path)} download={file.name}>  <GetAppIcon color="primary" /></a>
																	<CloseIcon onClick={() => this.onRemoveFile(file)} color='secondary' fontSize='small' />
																</span>
															</li>
														)}
														{attachments?.map((attachments) =>
															<li className='list-inline-item'>
																<span className='file-name'>{attachments.file_name}</span>
																<span className='file-remove'>
																	<a href={decodeURIComponent(attachments.file)} download={attachments.file_name}>  <GetAppIcon color="primary" /></a>
																	<CloseIcon onClick={() => this.onRemoveCamoFile(attachments)} color='secondary' fontSize='small' />
																</span>
															</li>
														)}
													</ul>
												</div>
												:
												<div className='checklist-files'>
													<ul className='list-inline'>
														{data?.checklist?.files?.map((file) =>
															<li className='list-inline-item'>
																<span className='file-name'>{file.name}</span>
																<span className='file-remove'>
																	<a href={decodeURIComponent(file.path)} download={file.name}>  <GetAppIcon color="primary" /></a>
																	<CloseIcon onClick={() => this.onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
																</span>
															</li>
														)}
														{(data.checklist?.folders?.length > 0) &&
															data.checklist?.folders.map((file) => {
																return (
																	<li className='list-inline-item' key={file.id}>
																		<Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
																			<a href={`${config.domain.records}${assetType[this.props.props?.match.params.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new"><img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Reacords Data Room" /></a>
																		</Tooltip>
																		<span className='file-name'>{file.name}</span>
																		<span className='file-remove'>
																			<CloseIcon onClick={() => this.onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
																		</span>
																	</li>
																);
															})}
														{attachments?.map((attachments) =>
															<li className='list-inline-item'>
																<span className='file-name'>{attachments.file_name}</span>
																<span className='file-remove'>
																	<a href={decodeURIComponent(attachments.file)} download={attachments.file_name}>  <GetAppIcon color="primary" /></a>
																	<CloseIcon onClick={() => this.deleteAttachmentFile(attachments.id, attachments)} color='secondary' fontSize='small' />
																</span>
															</li>
														)}
													</ul>
												</div>}
										</Grid>
									</Grid>
								</Grid>
							</DialogContent>
							<DialogActions className="actions-btn">
								<Button
									type="button"
									className="btn btn-primary"
									disabled={submitLoader}
									onClick={this.props.actionType === "add" ? (e) => this.addFormData(e) : (e) => this.updateData(e)}
								>
									{this.props.actionType === "add" ? "Add" : "Update"}
								</Button>

								{this.props.actionType === "add" ? (<Button disabled={submitLoader} onClick={(e) => this.saveAndAddAnother(e)} type="button" className="btn btn-primary" > Save & Add Another </Button>
								) : (
									""
								)}
								<Button type="button" className="btn btn-primary" onClick={() => { this.props.closeAddForm(); this.listResponseBack() }} > Close </Button>
							</DialogActions>
							<Dialog
								open={this.state.open}
								onClose={this.handleCloseAttachment}
								id="htDialog"
							>
								<LLpConfirmDeleteAttachment
									handleCloseAttachment={() => this.handleCloseAttachment()}
									deleteAttachmentFile={() =>
										this.deleteAttachmentFile(this.state.deleteAttachmentId)
									}
								/>
							</Dialog>
							<Dialog open={this.state.linkFile} onClose={this.handleCloseFile} id="htDialog">
								<LinkFiles
									handleClose={() => this.handleCloseFile()}
									uuid={this.props?.uuid?.uuid}
									editFormId={this.props.editFormId}
									getResponseBack={(file) => this.getResponseBack(file)}
									listResponseBack={(file) => this.listResponseBack(file)}
									actionType={this.props.actionType}
									onLinkFile={(file, any, type) => this.onLinkFile(file, any, type)}
									modType="llp"
									uploadFileInfo={data}
									last_used_folder_uuid={this.props.last_used_folder_uuid_link_document}
									attachments={attachments}
									type="link"
								/>
							</Dialog>
							<Dialog open={this.state.uploadFile} onClose={this.handleUploadFileCloseFile} id="htDialog">
								<UploadFile
									handleClose={() => this.handleUploadFileCloseFile()}
									uuid={this.props?.uuid?.uuid}
									editFormId={this.props.editFormId}
									getResponseBack={(file) => this.getResponseBack(file)}
									listResponseBack={(file) => this.listResponseBack(file)}
									actionType={this.props.actionType}
									onLinkFile={(file, uuid) => this.onLinkFile(file, uuid)}
									modType="llp"
									uploadFileInfo={data}
									last_used_folder_uuid={this.props.last_used_folder_uuid}
									onUpload={(file) => this.onUpload(file)}
									type="upload"
									checkbox_last_used_folder_uuid={this.props.checkbox_last_used_folder_uuid}
									checkbox_last_used_folder_name={this.props.checkbox_last_used_folder_name}
								/>
							</Dialog>
						</form>
					</div>
				</div>
				{(pageLoader || submitLoader) ? <PageLoader/> : null}
			</Fragment>
		)
	}
}

export default LLpTaskForms